module.exports = __webpack_public_path__ + "static/media/event-videos.c84ea0e5.svg";